/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './PromotionsCard.scss';

import { string, bool } from 'prop-types';
import React from 'react';

import { transformPromo } from 'state/IRT/IRTMessagesReducer';

const PromotionsCard = ({
  messageText,
  imageMax,
  isMarketingTest,
  messageId,
  messageName
}) => {
  if (messageText && imageMax) {
    return (
      <a
        href={
          isMarketingTest
            ? transformPromo(imageMax, messageId, messageText).messageText
            : messageText
        }>
        <img
          className="promotions-card-image"
          src={imageMax}
          alt={messageName}
        />
      </a>
    );
  }
  return null;
};

PromotionsCard.propTypes = {
  messageText: string,
  imageMax: string,
  testAndTarget: bool,
  messageId: string,
  mboxContainer: string,
  messageName: string
};

export default PromotionsCard;
